import HTTPService from '../HTTPService'

class Live {
  authToken (companySlug) {
    return HTTPService.get(`company/${companySlug}/live`)
  }

  privateChannelToken (companySlug, payload) {
    return HTTPService.post(`company/${companySlug}/live/subscribe`, {
      client: payload.client,
      channels: payload.channels // String[]
    })
  }

  ping (companySlug) {
    return HTTPService.get(`company/${companySlug}/live/ping`)
  }
}

export default new Live()
